import { Grid } from "@material-ui/core";
import React from "react";
import backWave2 from "../../../assets/image/backWawe2.svg";
import address from "../../../assets/image/address.svg";
import footerLogoImage from "../../../assets/image/logo.svg";
import useStyles from "../../../styles";

export default function MobFooter() {
    const classes = useStyles();
    return (
        <Grid container style={{ position: "relative" }}>
            <Grid container direction="column" alignItems="center" className={classes.mobFooterData}>
                <img src={footerLogoImage} alt="LogoImage" className={classes.mobLogoFooter} />
                <Grid item className={classes.mobPhoneNumber} style={{maxWidth:"90%",textAlign: "center",marginBottom: 10 }}>
                    تهران ، خیابان شریعتی ،پایین تر از ملک ،کوچه شکوری،پلاک 8
                </Grid>
                <Grid item className={classes.mobPhoneNumber}>
                    02177500130
                </Grid>
            </Grid>
            <img src={backWave2} alt="backWave" style={{ width: "100%", transform: "rotate(180deg)" }} />
        </Grid>
    );
}
